import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

const ContainerIcon = ({
  className,
  containerColor,
  containerSize,
  icon,
  onClick,
  round,
}) => (
  <WithIconRounded
    className={className}
    containerColor={containerColor}
    containerSize={containerSize}
    onClick={onClick}
    round={round}
  >
    {icon}
  </WithIconRounded>
);

ContainerIcon.propTypes = {
  className: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  round: PropTypes.bool,
};

ContainerIcon.defaultProps = {
  className: null,
  containerColor: 'var(--k-ds-color-white)',
  containerSize: 48,
  onClick: null,
  round: true,
};

export default ContainerIcon;
